module.exports = __webpack_public_path__ + "static/media/2-2_Duplex_White_02.425d2bfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/2-2_Duplex_White_02.jpg
// module id = 1705
// module chunks = 0